module.exports = __webpack_public_path__ + "assets/create_folder.494a9c57.svg";